import { createActionType } from 'utils/redux';
import { apiGetTimelines } from 'constants/apiRouting';
import { handleErrors } from 'utils/api';
import axios from 'axios';


export const GET_TIMELINES = createActionType('GET_TIMELINES');
export const CREATE_TIMELINE = createActionType('CREATE_TIMELINE');


export const getTimelines = (params = {}) => dispatch => (
  dispatch({
    type: GET_TIMELINES.name,
    payload: axios.get(
      apiGetTimelines(),
      { withCredentials: true, params },
    ).catch(error => handleErrors(error, dispatch)),
  })
);

export const createTimeline = params => dispatch => (
  dispatch({
    type: CREATE_TIMELINE.name,
    payload: axios.post(
      apiGetTimelines(),
      params,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  })
);
